module.exports = __webpack_public_path__ + "../resources/img/ic_save_gray950.69695648.svg";